module.exports = __webpack_public_path__ + "img/Receipt.a152fb3e.svg";